import React, { useState, useEffect, useMemo } from "react";
import { useGetTechnoQuery } from "../../redux/services/apiHome";
import Loader from "../../components/Loader";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { convertDateFormat } from "../../Utils/utils";
import Pagination from "../../components/Pagination/Pagination";
import usePagination from "../../hooks/usePagination";
import TenderSearch from "../../components/TenderSearch";
import { useTableResponsive } from "../../hooks/useTableResponsive";
import useSeo from "../../hooks/useSeo";
import { useLocation } from "react-router-dom";
import PdfZipItem from "../../components/PdfZipItem";

const QualifiedBidders = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredTenders, setFilteredTenders] = useState([]);
  const {
    data: qualifiedBiddersData = [],
    isLoading: qualifiedBiddersIsLoading,
  } = useGetTechnoQuery({
    lang: languageType,
  });

  useTableResponsive(qualifiedBiddersData);

  useEffect(() => {
    if (searchTerm) {
      const filtered = qualifiedBiddersData.tender_data.filter((item) =>
        item.title.toLowerCase().includes(searchTerm.toLowerCase()),
      );
      setFilteredTenders(filtered);
    } else {
      setFilteredTenders(qualifiedBiddersData.tender_data);
    }
  }, [searchTerm, qualifiedBiddersData]);

  const { currentItems, currentPage, totalPages, handlePageChange } =
    usePagination(filteredTenders, 12);

  // console.log(currentItems);

  const lastUpdatedOn = useMemo(() => {
    return convertDateFormat(
      qualifiedBiddersData?.tender_data?.[0]?.last_update_date,
    );
  }, [qualifiedBiddersData]);

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  if (qualifiedBiddersIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Tender", "निविदा")}
        titleLink="/tender/qualified-bidders"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-6 col-lg-6 mb-3 d-flex justify-content-between">
                <TenderSearch
                  setSearchTerm={setSearchTerm}
                  title={"Tender Number"}
                />
              </div>
              <div className="col-12 col-md-6 col-lg-6 mb-3 d-flex justify-content-end">
                <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 ">
                <div className="table-responsive">
                  <table className="table table-striped custom-table">
                    <thead className="thead-dark">
                      <tr>
                        <th>{getText("Tender Date", "निविदा")}</th>
                        <th>{getText("Tender Number", "निविदा संख्या")}</th>
                        <th>{getText("Tender Description", "निविदा विवरण")}</th>
                        <th>
                          {getText(
                            "List of Techno-Commercially Qualified Bidders",
                            "तकनीकी-व्यावसायिक रूप से योग्य बोलीदाताओं की सूची",
                          )}
                        </th>
                        {/* <th>{getText("Remarks", "टिप्पणियों")}</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems?.length > 0 ? (
                        currentItems?.map((item, index) => (
                          <tr key={index}>
                            <td className="no-wrap-td">
                              {convertDateFormat(item.field_tender_date_value)}
                            </td>
                            <td
                              className="no-wrap-td"
                              data-key={getText(
                                "Tender Number",
                                "निविदा संख्या",
                              )}
                            >
                              <PdfZipItem
                                filePath={item?.uri}
                                title={item.title}
                                filesize={item.file_size}
                              />
                            </td>
                            <td
                              data-key={getText(
                                "Tender Description",
                                "निविदा विवरण",
                              )}
                              dangerouslySetInnerHTML={{
                                __html:
                                  item.field_short_notice_inviting_bids_value,
                              }}
                            ></td>
                            <td
                              className="no-wrap-td"
                              data-key={getText(
                                "List of Techno-Commercially Qualified Bidders",
                                "तकनीकी-व्यावसायिक रूप से योग्य बोलीदाताओं की सूची",
                              )}
                            >
                              <div className="my-2">
                                {item.tender_details_of_techno_commerc &&
                                  item?.tender_details_of_techno_commerc?.files?.map(
                                    (subitem, i) => (
                                      <PdfZipItem
                                        key={i}
                                        filePath={subitem?.file_uri}
                                        title={subitem.file_description}
                                        filesize={subitem.file_size}
                                      />
                                    ),
                                  )}
                              </div>
                            </td>
                            {/* <td data-key={getText("Remarks", "टिप्पणियों")}>
                              <div className="my-2">
                                {item.tender_details_of_techno_commerc &&
                                  item?.tender_details_of_techno_commerc?.files?.map(
                                    (subitem, i) => (
                                      <React.Fragment key={i}>
                                        <div>{subitem.field_remarks_value}</div>
                                      </React.Fragment>
                                    ),
                                  )}
                              </div>
                            </td> */}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No records found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QualifiedBidders;
